<template>

  <div class="quote grid grid__item_span-12 p0 m0">

    <h2 class="uppercase txtCharcol grid__item_span-12 p0" v-bind:style="{ color: item.quote_text_colour }">{{item.quote_sub_heading}}</h2>
    <p class="quote grid__item_span-11 m0 p0" v-bind:style="{ color: item.quote_text_colour }">{{item.project_quote}}</p>
    
  </div>

</template> 

<script>

import animateScroll from '../../assets/js/projectAnimation.js'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'Quote',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    animateElements () {
      animateScroll.animate()
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/quote.vue